import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUserAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUserAddRight"><Path d="M13.168 12.1699C15.4663 13.5755 17 16.1087 17 19V21H1V19C1 16.109 2.53311 13.5755 4.83105 12.1699C5.95551 13.1237 7.41009 13.7002 9 13.7002C10.5896 13.7002 12.0436 13.1234 13.168 12.1699Z" fill="currentColor"/><Path d="M21 10H24V12H21V15H19V12H16V10H19V7H21V10Z" fill="currentColor"/><Path d="M9 2.5C11.6234 2.5 13.75 4.62665 13.75 7.25C13.75 9.87335 11.6234 12 9 12C6.37665 12 4.25 9.87335 4.25 7.25C4.25 4.62665 6.37665 2.5 9 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUserAddRight;
